import { fetchChannels } from "../apis/admin";

export async function loadAdminChannelsPageData({ request }) {
    const url = new URL(request.url)
    const orgID = url.searchParams.get('orgID')
    let params = {}
    if (orgID) {
        params.orgID = orgID
    }
    const { error, channels } = await fetchChannels(params);
    if (error) {
        throw new Error(error);
    }

    return { channels };
}
